/* eslint-disable no-func-assign */
import { FC } from "react";
import styles from "./Portfolios.module.css";
import Card from "../Card/Card";
import useWindowSize from "../../hooks/useWindowSize";
import { PortfolioDb } from "../../models/portfolio.db";
import { cardWidth } from "../../utils/layoutUtils";

interface Props {
  items: Array<PortfolioDb>;
  onShowModal: () => void;
  emptyString: string;
}
const PortfoliosList: FC<Props> = ({ items, onShowModal, emptyString }) => {
  const windowSize = useWindowSize();
  const width = cardWidth(windowSize.width);
  return (
    <div className={styles.listCards}>
      {items.length ? (
        items.map((item) => {
          return (
            <Card
              key={item.id}
              onShowModal={onShowModal}
              onClick={onShowModal}
              itemPhotoURL={item.picUrl}
              brandName={""}
              itemShoppingUrl={""}
              width={width}
            />
          );
        })
      ) : (
        <div
          style={{
            width: "100%",
            height: "50vh",
            display: "flex",
            alignSelf: "center",
            justifySelf: "center",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {emptyString}
        </div>
      )}
    </div>
  );
};
export default PortfoliosList;
